module.exports = __webpack_public_path__ + "static/img/14000533.b89da04c.png";